// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-info {\n  color: #888;\n  height: 30px;\n  line-height: 12px;\n}\n.bottom-info a {\n  color: #888;\n}\n.bottom-info div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.bottom-info div span {\n  margin: 0 3px;\n}", ""]);
// Exports
module.exports = exports;
